export default "__VITE_ASSET__4654e57a__"